import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-number-input";
import "flowbite";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useAccount } from "wagmi";
import { BoxAddress } from "./Contracts/Box";
import { BoxAbi } from "./Contracts/Box";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useSigner } from "wagmi";
import { ethers } from "ethers";
import Loading from "./Loading";
import { Toaster, toast } from "react-hot-toast";
import { BsCheckAll } from "react-icons/bs";
import { RxCross1 } from "react-icons/rx";

const SecondRequest = () => {
  const { id, email, wallet } = useParams();
  // console.log("Paramsssssss",id)
  const [phoneno, setPhoneno] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { address } = useAccount();
  const { isConnected } = useAccount();
  const [phonenoLogin, setPhonenoLogin] = useState();
  // const [email, setEmail] = useState("");
  const [emailLogin, setEmailLogin] = useState("");
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [phone, setPhone] = useState();
  const [OTP, setOTP] = useState("");
  const [OTPSent, setOTPSent] = useState(false);
  const [OTPVerified, setOTPVerified] = useState(false);
  // const [isVerified, setIsVerified] = useState(false);
  const [emailOTP, setEmailOTP] = useState(null);
  const [phoneOTP, setPhoneOTP] = useState(null);
  const [showmodal, setShowmodal] = useState(true);

  const [otpcheck, setOtpcheck] = useState(false);
  const { data: signer } = useSigner();

  const navigate = useNavigate();
  let boxcontract;
  if (signer) {
    boxcontract = new ethers.Contract(id, BoxAbi, signer);
  }

  // useEffect(() => {
  //   if (signer) {

  //     getFiles();

  //   }
  // }, [signer]);

  // const sendOTPRequest = async () => {
  //   const res = await axios.post(
  //     `${process.env.REACT_APP_SERVER_URL}/phone-otp`,
  //     { number: number }
  //   );
  //   if (res.data.success) {
  //     setOtpcheck(true);
  //   }
  //   console.log("Successfuly ", res.data.OTP);
  // };

  const registerUser = async () => {
    // if (req == 1) {
    setIsLoading(true);
    await axios
      .post(`${process.env.REACT_APP_SERVER_URL}/check-availability`, {
        email: email,
        boxAddress: id,
      })
      .then(async (res) => {
        console.log("Successfuly ", res.data);
        if (res.data.success && res.data.isfirstTime) {
          await axios
            .post(`${process.env.REACT_APP_SERVER_URL}/re-request-box/`, {
              email: email,
              walletAddress: wallet,
              boxAddress: id,
              status: false,
            })
            .then(async (res) => {
              console.log(res);
              if (res.data.success) {
                setIsLoading(false);
                toast.success(
                  "Succesfully Requested, You will recieve email after approval"
                );
              } else {
                setIsLoading(false);
                toast.success("Error !!! please try again later");
              }
            });
        } else {
          setIsLoading(false);
          toast.error("Already Requested");
        }
      });

    // alertethereu(res.data.msg);

    // navigate("/dashboard");
    //           })
    //       )
    //       .catch((err) => {
    //         console.log("error ", err.message);
    //         setIsLoading(false);
    //       });
    //   } else {
    //     console.log("error ", res);
    //     setIsLoading(false);
    //     toast.success("Already Requested");

    //     // alert(res.data.msg)
    //   }
    // });
    // }
    // else {
    //   await axios
    //     .post(`${process.env.REACT_APP_SERVER_URL}/req-access`, {
    //       invitationId: id,
    //     })
    //     .then(async (res) => {});
    // }
  };

  return (
    <>
      <div className={` flex justify-between bg-[#212445] px-6 py-2`}>
        <Toaster position="top-center" reverseOrder={false} />

        <div>
          <button className="bg-[#2F47FA] text-white hidden rounded-lg p-3">
            Request Access
          </button>
        </div>
        <div>
          <Loading isLoading={isLoading} />
          <ConnectButton />
        </div>
      </div>
      {/* //    <!-- component --> */}
      <div
        className={`${
          isLoading ? " blur-2xl " : ""
        } bg-gradient-to-b from-[#212445] via-[#212445] to-[#2a2f6c] py-20 px-10 min-h-screen`}
      >
        <h1 className="mx-auto text-white font-bold text-center text-4xl">
          Box Request
        </h1>

        <div className="bg-transparent p-10 md:w-3/4 lg:w-1/2 mx-auto mt-10">
          <div className="items-center mb-5">
            <label className="block mb-2 text-sm text-left font-medium text-white dark:text-white">
              Email
            </label>
            <input
              type="email"
              disabled={true}
              placeholder="Email"
              value={email}
              className="flex-1 py-2 border-b-2 border-gray-800 bg-white focus:border-green-400 
                      text-gray-600 placeholder-[#2F47FA]
                      outline-none rounded-lg  w-full p-2.5 "
              // onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div>
            <label
              htmlFor="password"
              className="block mb-2 text-sm font-medium text-white dark:text-white"
            >
              Wallet Address
            </label>

            <input
              disabled={true}
              value={wallet}
              placeholder="Wallet Address"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
            />
          </div>

          <div className="text-center rounded-lg bg-[#2F47FA] mt-6">
            <button
              className="py-3 px-8 bg-transparent text-white font-bold"
              data-modal-target="userverification-modal"
              data-modal-toggle="userverification-modal"
              onClick={registerUser}
            >
              Request
            </button>
          </div>
        </div>
      </div>

      {/* ..........................Email Login.................... */}
      {/* <div
        id="email-modal"
        tabindex="-1"
        aria-hidden="true"
        className="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full backdrop-blur"
      >
        <div className="relative w-full h-full max-w-md md:h-auto">
          {/* <!-- Modal content --> */}
      {/* <div className="relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#2a2f6c] rounded-lg shadow ">
            <button
              type="button"
              className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
              data-modal-hide="email-modal"
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
            <div className="px-6 py-6 lg:px-8">
              <h3 className="mb-4 text-xl font-medium text-white dark:text-white">
                Sign in to our platform
              </h3>

              <div>
                <label
                  htmlFor="email"
                  className="block mb-2 text-sm font-medium text-white dark:text-white"
                >
                  Enter Email
                </label>
                <input
                  type="email"
                  onChange={(e) => setEmailLogin(e.target.value)}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                  placeholder="Email"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block mb-2 text-sm font-medium text-white dark:text-white"
                >
                  Enter Email
                </label>
                <input
                  type="Password"
                  onChange={(e) => setEmailLogin(e.target.value)}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                  placeholder="Enter Passowrd"
                  required
                />
              </div>

              <button
                data-modal-target="loginverification-modal"
                data-modal-toggle="loginverification-modal"
                data-modal-hide="email-modal"
                className="w-full text-white mt-4 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Verify
              </button>
            </div>
          </div> */}
      {/* </div> */}
      {/* </div> */}
    </>
  );
};

export default SecondRequest;
